import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import productCategory from "../helpers/productCategory";
import VerticalCard from "../components/VerticalCard";
import SummaryApi from "../common";

const CategoryProduct = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sortBy, setSortBy] = useState("");

  const location = useLocation();
  const navigate = useNavigate();

  /* -----------------------------------
     Get selected categories from URL
  ------------------------------------ */

const selectedCategories = useMemo(() => {
  const params = new URLSearchParams(location.search);
  return params.getAll("category");
}, [location.search]);

  /* -----------------------------------
     Fetch products
  ------------------------------------ */
  const fetchData = useCallback(async () => {
    setLoading(true);

    const body =
      selectedCategories.length > 0
        ? { category: selectedCategories }
        : { category: productCategory.map(c => c.value) }; // ALL if none selected

    try {
      const response = await fetch(SummaryApi.filterProduct.url, {
        method: SummaryApi.filterProduct.method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      const dataResponse = await response.json();
      setData(dataResponse?.data || []);
    } catch (err) {
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [selectedCategories])

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  /* -----------------------------------
     Handle checkbox click
  ------------------------------------ */
  const handleSelectCategory = (e) => {
    const { value, checked } = e.target;

    const params = new URLSearchParams(location.search);
    let current = params.getAll("category");

    if (checked) {
      if (!current.includes(value)) current.push(value);
    } else {
      current = current.filter((c) => c !== value);
    }

    const query = current.map((c) => `category=${c}`).join("&");
    navigate("/product-category?" + query);
  };

  /* -----------------------------------
     Sort
  ------------------------------------ */
  const handleOnChangeSortBy = (e) => {
    const value = e.target.value;
    setSortBy(value);

    if (value === "asc") {
      setData((prev) => [...prev].sort((a, b) => a.sellingPrice - b.sellingPrice));
    }

    if (value === "dsc") {
      setData((prev) => [...prev].sort((a, b) => b.sellingPrice - a.sellingPrice));
    }
  };

  return (
    <div className="container mx-auto px-4 py-4">

      {/* Mobile Filters */}
      <div className="lg:hidden bg-white p-3 mb-4 shadow rounded">
        <h3 className="font-medium mb-2">Sort By</h3>

        <div className="flex gap-4 mb-3 text-sm">
          <label>
            <input type="radio" value="asc" checked={sortBy === "asc"} onChange={handleOnChangeSortBy} />
            Low → High
          </label>
          <label>
            <input type="radio" value="dsc" checked={sortBy === "dsc"} onChange={handleOnChangeSortBy} />
            High → Low
          </label>
        </div>

        <h3 className="font-medium mb-2">Category</h3>

        <div className="grid grid-cols-2 gap-2 text-sm">
          {productCategory.map((cat) => (
            <label key={cat.value} className="flex gap-2">
              <input
                type="checkbox"
                value={cat.value}
                checked={selectedCategories.includes(cat.value)}
                onChange={handleSelectCategory}
              />
              {cat.label}
            </label>
          ))}
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="hidden lg:grid grid-cols-[220px,1fr] gap-4">

        <div className="bg-white p-3">
          <h3 className="font-medium mb-2">Category</h3>

          {productCategory.map((cat) => (
            <label key={cat.value} className="flex gap-2 text-sm">
              <input
                type="checkbox"
                value={cat.value}
                checked={selectedCategories.includes(cat.value)}
                onChange={handleSelectCategory}
              />
              {cat.label}
            </label>
          ))}
        </div>

        <div>
          <p className="my-2">Results: {data.length}</p>
          <VerticalCard data={data} loading={loading} />
        </div>

      </div>

      {/* Mobile products */}
      <div className="lg:hidden">
        <VerticalCard data={data} loading={loading} />
      </div>

    </div>
  );
};

export default CategoryProduct;
